export const SET_COMPANIES_DATA = 'SET_COMPANIES_DATA'
export const SET_FILTER = 'SET_FILTER'
